import type { ReactNode } from 'react';

interface KpiRowProps {
  children: ReactNode;
  columns?: number;
}

export const KpiRow = ({ children, columns = 12 }: KpiRowProps) => (
  <section aria-label="Summary">
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 'var(--bui-space-4)',
        alignItems: 'stretch',
      }}
    >
      {children}
    </div>
  </section>
);
